import {
	Button, ButtonAppearance, LoaderBars, RemoveIcon,
} from '@aleph/shared-components';
import EntityOwnerDisplay from 'wb-reddit/app/common/components/EntityOwnerDisplay';
import { useTranslation } from 'react-i18next';

interface IProps {
	isOwner?: boolean
	isCurrentUser?: boolean
	loading?: boolean
	onClick: () => Promise<void>
}

function AccessListItemRevoke({
	isOwner, isCurrentUser, loading, onClick,
}: IProps) {
	const { t } = useTranslation();

	if (isOwner) {
		return <EntityOwnerDisplay />;
	}

	if (!isCurrentUser) {
		return (
			<Button
				leftNode={loading ? <LoaderBars className="animate-spin" /> : <RemoveIcon />}
				appearance={ButtonAppearance.GHOST}
				color="gray"
				onClick={onClick}
				disabled={loading}
			/>
		);
	}

	return <span className="text-[12px]">{t('sc: menu.you', 'You')}</span>;
}

export default AccessListItemRevoke;
